export const CALENDAR_ATTENDANCE_LEGEND = [
  { code: 'P', label: 'Present' },
  { code: 'A', label: 'Absent' },
  { code: 'L', label: 'Leave' },
  { code: 'W', label: 'WFH' },
];

export const CALENDAR_ATTENDANCE_STYLES = {
  P: {
    badgeClassName: 'bg-green-100 text-green-700',
    emphasisClassName: 'text-green-800',
  },
  A: {
    badgeClassName: 'bg-red-100 text-red-700',
    emphasisClassName: 'text-red-800',
  },
  L: {
    badgeClassName: 'bg-yellow-100 text-yellow-700',
    emphasisClassName: 'text-yellow-800',
  },
  W: {
    badgeClassName: 'bg-emerald-100 text-emerald-700',
    emphasisClassName: 'text-emerald-800',
  },
};

export const buildCalendarAttendanceCounts = (entries = []) => {
  const countsByCode = entries.reduce((acc, entry) => {
    const status = entry?.status;
    if (status === 'checked-in') {
      acc.P = (acc.P || 0) + 1;
      return acc;
    }

    if (status === 'not-checked-in') {
      acc.A = (acc.A || 0) + 1;
      return acc;
    }

    if (status === 'on-leave') {
      acc.L = (acc.L || 0) + 1;
      return acc;
    }

    if (status === 'work-from-home') {
      acc.P = (acc.P || 0) + 1;
      acc.W = (acc.W || 0) + 1;
      return acc;
    }

    return acc;
  }, {});

  return CALENDAR_ATTENDANCE_LEGEND.map(({ code, label }) => ({
    code,
    label,
    count: countsByCode[code] || 0,
  }));
};
